import React from "react"
import { graphql, StaticQuery } from "gatsby"
import styled from '@emotion/styled';
import { darkThemeColors, breakpoints } from '../util/styles';
import Img from "gatsby-image";

/**
 * Container for all products
 */
const MixtapeListing = (props) => (
    <StaticQuery
        query={graphql`
            query MyQuery {
                mixtapes: allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "mixtape-page"}}}) {
                edges {
                    node {
                    fields {
                        slug
                    }
                    id
                    frontmatter {
                        src
                        }
                    }
                }
            }
        }
    `}
        render={({ mixtapes }) => (
            <>
                <Heading>Mixtapes</Heading>
              <div className="columns is-multiline">

              {mixtapes.edges.map(({ node: mixtape }) =>
                    (
                      <iframe width="400px" height="400px"
                            src={mixtape.frontmatter.src}
                            frameBorder="2"/>
                )
                )
                }
              </div>

            </>
        )}
    />
);

const Heading = styled(`div`)`
    font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
    line-height: 1.3;
    font-size: 1.6rem;
    font-weight: 500;
    color: ${darkThemeColors.text};   
`
const Mixtape = styled(`div`)`
    border-radius: 4px;
    box-shadow: 0 1px 10px rgba(0, 0, 0, 1);
    overflow: hidden;
    text-decoration: none;
    margin-left: auto !important;
    margin-right: auto !important;

    @media (min-width: ${breakpoints.tablet}px) {
        max-width: 250px;
      }
    
      @media (min-width: ${breakpoints.desktop}px) {
        flex-basis: 300px;
        justify-content: center;
        margin: 16px;
      }
    
      @media (hover: hover) {
        :hover {
          background: ${darkThemeColors.brandLighter};
        }
      }
`

export default MixtapeListing;
